export default __webpack_public_path__ + "static/Montserrat-SemiBold-435978bd8e8afce6ad67039426f293c8.woff";